import { render, staticRenderFns } from "./BuyerPaymentMethod.vue?vue&type=template&id=2cdac896&scoped=true&"
import script from "./BuyerPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./BuyerPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./BuyerPaymentMethod.vue?vue&type=style&index=0&id=2cdac896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdac896",
  null
  
)

export default component.exports